import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { IMedicalInterface } from 'src/app/models/medical.inteface';

@Component({
  selector: 'app-medical-list-table',
  templateUrl: './medical-list-table.component.html',
  styleUrls: ['./medical-list-table.component.scss'],
})
export class MedicalListTableComponent implements OnInit {
  @Input() policies: IMedicalInterface[];
  filteredRows: IMedicalInterface[];
  selectedRecord: IMedicalInterface;
  tableFiltersFormGroup: FormGroup;
  @Input() dataLoaded: boolean;

  constructor(private formBuilder: FormBuilder, private router: Router) {
    this.tableFiltersFormGroup = this.formBuilder.group({
      searchFilter: '',
    });
    this.filterSearchTable();
  }

  ngOnInit(): void {
    this.filteredRows = this.policies;
  }

  filterSearchTable() {
    this.tableFiltersFormGroup
      .get('searchFilter')
      .valueChanges.subscribe((val) => {
        this.filteredRows = this.policies.filter((record) => {
          return Object.keys(record).reduce((acc, curr) => {
            return (
              acc ||
              JSON.stringify(record[curr])
                .toLowerCase()
                .includes(val.toLowerCase())
            );
          }, false);
        });
      });
  }

  checkDocs(policy: IMedicalInterface) {
    if (policy.hasDoc) {
      return {
        'background-color': '#fee440',
      };
    } else if (policy.hasOwnProperty('cancellation')) {
      return {
        'background-color': '#DB3A34',
        color: '#fff',
      };
    } else if (policy.hasDoc && policy.hasOwnProperty('cancellation')) {
      return {
        'background-color': '#DB3A34',
        color: '#fff',
      };
    }
  }

  goToPolicyDetails(_id: string) {
    this.router.navigate(['/medical/list/medical-details', _id]);
  }
}
